import { isEmpty } from "lodash";
import React, { forwardRef, useState, useCallback } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import PrismaCloudComputeMappingForm from "./PrismaCloudComputeMappingForm";
import { useFeatureFlag } from "contexts/FeatureFlagContext";
import { PRISMA_CLOUD_COMPUTE_URL } from "utils/documentationUtil";

function PrismaCloudComputeCredentialsForm(props, ref) {
  const featureFlags = useFeatureFlag();
  const [checked, setChecked] = useState(props.config?.fetchAssets === "true" ? true : false);
  const [apiEndpoints, setApiEndPoints] = useState(() => ({
    apiEndpoint: props.config?.apiEndpoint,
    codeApiEndpoint: props.config?.codeApiEndpoint,
  }));

  const apiValidation = () => {
    if (
      isEmpty(apiEndpoints?.["apiEndpoint"]) &&
      isEmpty(apiEndpoints?.["codeApiEndpoint"])
    ) {
      return Promise.reject("Please add one of the API endpoints.");
    }
    return Promise.resolve();
  };

  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint (Prisma Runtime Security)",
      rules: [
        urlRegexValidator(),
        {
          validator: apiValidation,
        },
      ],
      props: {
        onChange: (e) => {
          setApiEndPoints((prev) => ({ ...prev, apiEndpoint: e.target.value }));
        },
      },
      help: PRISMA_CLOUD_COMPUTE_URL,
    },
    {
      name: "codeApiEndpoint",
      label: "API Endpoint (Prisma Application Security/API Security)",
      rules: [
        urlRegexValidator(),
        {
          validator: apiValidation,
        },
      ],
      props: {
        onChange: (e) => {
          setApiEndPoints((prev) => ({
            ...prev,
            codeApiEndpoint: e.target.value,
          }));
        },
      },
      help: PRISMA_CLOUD_COMPUTE_URL,
    },
    {
      name: "adminConsoleUrl",
      label: "Admin Console URL",
      help: (
        <>
          Please enter your Prisma Tenant URL (For example:{" "}
          <a
            href="https://app2.prismacloud.io"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://app2.prismacloud.io
          </a>
          )
        </>
      ),
      required: true,
      rules: [urlRegexValidator],
    },
    {
      name: "username",
      label: "Access Key",
      required: true,
    },
    {
      name: "password",
      label: "Secret Key",
      type: FieldTypes.PASSWORD,
      required: true,
    },
    {
      name: "version",
      label: "Version",
    },
    ...(featureFlags.RBVM_ASSETS ? [{
      name: "fetchAssets",
      label: "Fetch Assets",
      type: FieldTypes.BOOLEAN,
      inline: true,
      props: {
        checked: checked,
        onChange: (e) => setChecked(e.target.checked),
      },
    }] : [])
  ];

  const parseExtraFields = useCallback((config) => {
    if (config?.fetchAssets) {
      return {
        ...config,
        fetchAssets: config.fetchAssets === "true" ? true : false,
      };
    }
    return config;
  }, []);

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      versionField={false}
      MappingForm={PrismaCloudComputeMappingForm}
      parseExtraFields={parseExtraFields}
    />
  );
}

export default forwardRef(PrismaCloudComputeCredentialsForm);
